import { render } from "./medicalNumDialog.vue?vue&type=template&id=55dff2b3&scoped=true"
import script from "./medicalNumDialog.vue?vue&type=script&lang=js"
export * from "./medicalNumDialog.vue?vue&type=script&lang=js"

import "./medicalNumDialog.vue?vue&type=style&index=0&id=55dff2b3&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dff2b3"]])

export default __exports__